import { requestGet as wsRequestGet } from './_wsApiFetchData';

// Device job queue (bookings run on a physical device). Read-only.

export async function searchDeviceJobs(filters, language, timeZone, cancelToken) {
    return await wsRequestGet('/admin/devicejobs/search', language, timeZone, filters, cancelToken);
}

export async function getDeviceJob(jobId, language, timeZone, cancelToken) {
    return await wsRequestGet(`/admin/devicejobs/${jobId}`, language, timeZone, null, cancelToken);
}

export async function getDeviceRunners(language, timeZone, cancelToken) {
    return await wsRequestGet('/admin/devicejobs/runners', language, timeZone, null, cancelToken);
}

export async function getDeviceJobSummary(language, timeZone, cancelToken) {
    return await wsRequestGet('/admin/devicejobs/summary', language, timeZone, null, cancelToken);
}
